import React, { useState, useEffect } from "react";
import { Card, Button, Divider, Tooltip, Modal, Input, Select } from "antd";
import { EditTwoTone, SaveTwoTone, SettingTwoTone, ArrowRightOutlined } from "@ant-design/icons";
import { Col, Row } from "reactstrap";
import StringIcon from "../../Assets/external_icons/color/solar-strings.png";
import ActiveBalancerIcon from "../../Assets/external_icons/active-balancer.png";
import LightIcon from "../../Assets/external_icons/color/light-bulb.png";
import FullChargeBatteryIcon from "../../Assets/external_icons/color/battery-charge.png";
import MidChargeBatteryIcon from "../../Assets/external_icons/color/battery-mid-charge.png";
import LowChargeBatteryIcon from "../../Assets/external_icons/color/battery-decharge.png";
import PanelGroup from "./PanelsGroup";
import { gql, useMutation, useQuery } from "@apollo/client";
import { error, success } from "../../Controllers/toast";

const CHANGE_BLOCK_NAME = gql`
  mutation ChangeBlockName($Opt_Group_id: Int!, $block_name: String, $Block_Group_id: Int!, $Block_Name_Id: Int) {
    ChangeBlockName(Opt_Group_id: $Opt_Group_id, block_name: $block_name, Block_Group_id: $Block_Group_id, Block_Name_Id: $Block_Name_Id) {
      Block_Group_Info {
        id
        block_name
      }
    }
  }
`;

const SAVE_ORDER = gql`
  mutation SavePanelOrder($panelsOrderList: [panelsOrderListInput], $Opt_Group_id: Int!, $order_index: String, $PanelsPerRow: Int) {
    SavePanelOrder(panelsOrderList: $panelsOrderList, Opt_Group_id: $Opt_Group_id, order_index:$order_index, PanelsPerRow:$PanelsPerRow) {
      serial_number
      order_index
    }
  }
`;

const GET_ACTIVE_BALANCER_DATA = gql`
  query GetActiveBalancerData($gatewayId: Int!) {
  GetActiveBalancerData(Gateway_id: $gatewayId) {
    Balancer_id
    serial_number
    Active_Balancer_Data {
      date_time
      Ineutral
      Ineutral_rms
      Vline_neg
      Vline_pos
      Vearth
      Ths
      Tamb
    }
  }
}

`;

const checkTime = (date_time) => new Date().getTime() - 300000 < date_time;

const PannelMapComponent = ({ PO_groups, lang_choiced, blockIndex, plantId }) => {
  const [path, setPath] = useState([]);
  const [blockNameInput, setBlockNameInput] = useState("");
  const [visible, setVisible] = useState(false);
  const [optimizersView, setOptimizersView] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [panelOrderList, setPanelOrderList] = useState([]);
  const [selectedGroupIds, setSelectedGroupIds] = useState({ Opt_Group_id: null, Block_Group_id: null });
  const [itemsPerRow, setItemsPerRow] = useState(10);
  const [showActiveBalancerTooltip, setShowActiveBalancerTooltip] = useState(false)

  const [changeBlockName] = useMutation(CHANGE_BLOCK_NAME, {
    onCompleted: () => {
      success("نام بلوک با موفقیت تغییر کرد!");
      setVisible(false);
    },
    onError: (err) => error(err.message),
  });

  const [savePanelOrder] = useMutation(SAVE_ORDER, {
    onCompleted: (res) => {
      success("ترتیب به‌روزرسانی شد!");
      setEditMode(false);
      setPanelOrderList([])
      // console.log(res, "is savePanelOrder")
    },
    onError: (err) => error("خطا در ذخیره ترتیب: " + err.message),
  });

  console.log(PO_groups.map(PO_group => PO_group), "is PO_groups")
  // const {  } = useQuery(GET_ACTIVE_BALANCER_DATA, {
  //     variables: { Gateway_id:17 },
  //     onCompleted: (res) => {
  //       // console.log(res.GetOptimizers, "is response");
  //       // setPO_groups(res.GetOptimizers);
  //     },
  //     onError: (err) => {
  //       console.log(err);
  //       error("مشکلی در دریافت اطلاعات رخ داده است!");
  //     },

  //     //  notifyOnNetworkStatusChange: true,
  //     pollInterval: 20000,
  //     // errorPolicy: "ignore",
  //   });

  const sortedPOGroups = [...PO_groups].sort((a, b) => (a.gateway.order || "").localeCompare(b.gateway.order || ""));


  const handleSaveOrder = (PO_group) => {
    // console.log(PO_group.order_index, itemsPerRow, panelOrderList, "is panelOrderList")
    if (!PO_group.Opt_Group_id) return error("بلوک یافت نشد!");
    else if (panelOrderList.length === 0) savePanelOrder({
      variables: { Opt_Group_id: PO_group.Opt_Group_id, panelsOrderList: [], PanelsPerRow: itemsPerRow },
    });
    else savePanelOrder({
      variables: { Opt_Group_id: PO_group.Opt_Group_id, panelsOrderList: panelOrderList, order_index: PO_group.order_index, PanelsPerRow: itemsPerRow },
    });
  };

  const calculateTotalPower = () =>
    PO_groups.reduce((total, block) => {
      const data = block?.gateway?.group_data?.[0];
      if (data && checkTime(data.date_time)) {
        const power = Math.ceil(Math.round(data.Vline * data.Iline) / 10000) / 1000;
        return total + power;
      }
      return total;
    }, 0).toFixed(2);

  const renderOptimizers = (PO_group, index) => {
    // setItemsPerRow(PO_group.panelsPerRow)
    // console.log(PO_group.panelsPerRow , "is PO_group.panelsPerRow")
    const aggr = PO_group.optimizers.map((opt) => ({ serial_number: opt.serial_number, ...opt.Last_Production[0] }));
    return (
      <>
        {path.length > 0 && (
          <Button
            onClick={() => {
              setPath([]);
              setOptimizersView(false);
              setActiveIndex(null);
              setEditMode(false);
            }}
            style={{ marginBottom: "16px", marginLeft: "16px" }}
            type="dashed"
          > <ArrowRightOutlined />
            بازگشت
          </Button>
        )}
        {editMode ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>

            <Select
              value={itemsPerRow}
              onChange={(val) => setItemsPerRow(val)}
              style={{ width: "auto" }}
              options={[{ label: "۵ در هر ردیف", value: 5 }, { label: "۱۰ در هر ردیف", value: 10 }]}
            />
            <Button icon={<SaveTwoTone />} onClick={() => handleSaveOrder(PO_group)}>
              ذخیره ترتیب
            </Button>
          </div>
        ) : (
          <Button icon={<SettingTwoTone />} onClick={() => setEditMode(true)} style={{ marginBottom: "10px" }}>
            ویرایش ترتیب
          </Button>
        )}
        <PanelGroup
          key={index}
          index={index + 1}
          PO_group={PO_group}
          lang_choiced={lang_choiced}
          plantId={plantId}
          Last_Productions={aggr}
          serial_number={PO_group.gateway.serial_number}
          panelOrderList={panelOrderList}
          setPanelOrderList={setPanelOrderList}
          itemsPerRow={itemsPerRow}
          editMode={editMode}
          setEditMode={val => setEditMode(val)}
        />
      </>
    );
  };

  const renderBlock = () =>
    sortedPOGroups.map((block, i) => {
      const gwSN = block.gateway.serial_number;
      const groupData = block.gateway?.group_data?.[0];
      const BatteryCharge = Math.ceil(Math.round(groupData?.BatteryCharge / 100));

      // ترتیب واقعی از لیست نهایی یا از order_index بلوک
      const foundOrder = panelOrderList.find((o) => o.serial_number === gwSN)?.order;
      const currentOrder = foundOrder || block.order_index || "0-0";

      const powerNow =
        groupData && checkTime(groupData?.date_time)
          ? Math.ceil(Math.round(groupData.Vline * groupData.Iline) / 10000) / 1000
          : 0;

      return (
        <Col key={i} xl={3} lg={4} md={4} sm={6} xs={12} className="text-center">
          <Card.Grid
            style={{
              width: "100%",
              textAlign: "center",
              cursor: "pointer",
              marginBottom: "5px",
              padding: 0,
              borderRadius: "10px",
            }}
            onClick={() => {
              setActiveIndex(i);
              setOptimizersView(true);
              // path الان بر اساس order_index ساخته میشه
              setPath(["s", block.order_index]);
              setItemsPerRow(PO_groups[i]?.panelsPerRow || 10);
            }}
          >
            <div
              style={{
                borderRadius: "10px",
                border: "1px solid grey",
              }}
              className="card mb-1"
            >
              <div className="card-header ltr">
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                  <img width={30} src={LightIcon} alt="light" /> {powerNow} <small>kW</small>
                </span>
                <Divider type="vertical" />
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                  <img
                    width={36}
                    src={
                      BatteryCharge >= 75
                        ? FullChargeBatteryIcon
                        : BatteryCharge >= 35
                          ? MidChargeBatteryIcon
                          : LowChargeBatteryIcon
                    }
                    alt="battery"
                  />
                  {BatteryCharge}%
                </span>
              </div>

              <div className="p-2 string-card-body text-center ">
                <p className="fs-16 p-1 mb-1">S/N Master: {gwSN}</p>
                {PO_groups[i]?.active_balancer&&<div>
                  <Divider className="m-0" />
                  {/* <Tooltip placement="bottom" title={
                  <div className="ltr">
                    <p className="mb-2">S/N: </p>
                    <Divider className="m-0"/>
                    
                  </div>
                }> */}
                  <Row className="mt-2">
                    <Col className="ltr">
                      <p>Null System (S\N:{PO_groups[i]?.active_balancer?.serial_number})</p>
                    </Col>
                  </Row>
                </div>}
                {/* </Tooltip> */}
                {/* <span className="fs-16 p-1">S/N:{gwSN}</span>
                <img width={32} src={StringIcon} alt="string-icon" /> */}
              </div>
            </div>
          </Card.Grid>

          {/* نمایش order فعلی بلوک */}
          <p style={{ fontSize: "17px", fontWeight: "bolder" }}>{currentOrder}</p>
        </Col>
      );
    });


  return (
    <div className="mb-4">
      <Modal
        title="تغییر اطلاعات"
        open={visible}
        okText="تغییر"
        cancelText="بازگشت"
        onOk={() =>
          changeBlockName({
            variables: {
              Opt_Group_id: selectedGroupIds.Opt_Group_id,
              block_name: blockNameInput,
              Block_Group_id: selectedGroupIds.Block_Group_id,
            },
          })
        }
        onCancel={() => setVisible(false)}
      >
        <div>
          <p>تغییر نام بلوک:</p>
          <Input value={blockNameInput} onChange={(e) => setBlockNameInput(e.target.value)} />
        </div>
      </Modal>

      <Card
        key={PO_groups[0].Opt_Group_id}
        title={
          <div style={{ marginTop: "10px" }}>
            <Tooltip title={"تغییر نام بلوک"}>
              <Button
                onClick={() => {
                  setBlockNameInput(PO_groups[0].blockgroups.Block_Group_Info.block_name);
                  setVisible(true);
                  setSelectedGroupIds({
                    Opt_Group_id: PO_groups[0].Opt_Group_id,
                    Block_Group_id: PO_groups[0].blockgroups.Block_Group_id,
                  });
                }}
                type="text"
              >
                <EditTwoTone style={{ fontSize: "17px" }} />
              </Button>
            </Tooltip>
            <b>{blockIndex + 1}</b>
            {" "}
            <span className="ltr" style={{ fontSize: "17px", fontWeight: 500 }}>
              ({PO_groups[0].blockgroups.Block_Group_Info.block_name})
            </span>

            <div style={{ marginTop: "10px" }}>مجموع توان مصرفی: <b className="ltr">{calculateTotalPower()}kW</b></div>
          </div>
        }
      >
        {optimizersView ? renderOptimizers(sortedPOGroups[activeIndex], activeIndex) : <Row>{renderBlock()}</Row>}
      </Card>
    </div>
  );
};
export default React.memo(PannelMapComponent);
